var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRunnaMini(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_58",
    "data-name": "Group 58",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 918.656,
    height: 592.33,
    viewBox: "0 0 918.656 592.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_43",
    "data-name": "Rectangle 43",
    width: 918.656,
    height: 592.33,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_57",
    "data-name": "Group 57",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M323.389,46.095a25.658,25.658,0,0,0-11.765,2.855l-124.716,64.1a25.789,25.789,0,0,0-12.443,31.811,26.5,26.5,0,0,1,8.472-6.883L290.842,82.518a41.218,41.218,0,0,1,55.436,17.8l8.394,16.327a19.662,19.662,0,0,0,25.425,9.021L346.408,60.116a25.863,25.863,0,0,0-23.02-14.021",
    transform: "translate(96.998 25.862)",
    fill: "#aa1a40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M175.395,159.105a26.563,26.563,0,0,1,4.686-8.634,25.788,25.788,0,0,1,12.445-31.811l124.715-64.1a25.836,25.836,0,0,1,34.783,11.168l33.69,65.547c.371-.164.746-.317,1.108-.5l12.806-6.582L365.91,58.59A41.5,41.5,0,0,0,310.1,40.675l-124.716,64.1a41.448,41.448,0,0,0-17.914,55.8l9.028,17.567a26.37,26.37,0,0,1-1.107-19.04",
    transform: "translate(91.381 20.253)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M708.85,127.057a12.794,12.794,0,0,1-6.369,7.509L261.559,361.186a12.9,12.9,0,0,1-17.344-5.557l463.823-238.39a12.78,12.78,0,0,1,.812,9.819",
    transform: "translate(137.02 65.778)",
    fill: "#895d3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M713.8,129.963,249.978,368.353l-14.6-28.412a12.874,12.874,0,0,1,5.526-17.328L341.082,271.13,557.774,159.748l13.878-7.134L682.066,95.885a12.667,12.667,0,0,1,5.667-1.327,12.894,12.894,0,0,1,11.473,6.978Z",
    transform: "translate(131.257 53.053)",
    fill: "#c6915d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M720.991,166.769,280.068,393.4a28.519,28.519,0,0,1-38.355-12.317L227.1,352.676a28.471,28.471,0,0,1,2.982-30.659l5.963,11.583,10.475-5.386a12.873,12.873,0,0,0-5.526,17.328l14.6,28.411a12.9,12.9,0,0,0,17.343,5.557l440.923-226.62a12.861,12.861,0,0,0,5.557-17.328l-14.6-28.427a12.9,12.9,0,0,0-11.474-6.978,12.672,12.672,0,0,0-5.666,1.327L698,96.178l-3.575-6.947c-.8-1.561-1.639-3.106-2.5-4.621A28.48,28.48,0,0,1,718.7,100l14.611,28.411a28.515,28.515,0,0,1-12.316,38.355",
    transform: "translate(125.645 47.453)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M459.84,59,417.668,80.676,435,90.653a20.054,20.054,0,1,1-5.451,9.469L408.673,88.107l-1.687,24.248a19.9,19.9,0,1,1-26.125,14.2l-23.21-12.834L354.679,137.9a19.9,19.9,0,1,1-10.848-1.311l2.355-19.171-28,14.39a35.074,35.074,0,0,1-20.271,3.669l57.649,112.162,159.178-81.812Z",
    transform: "translate(167.152 33.103)",
    fill: "#ff335f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M371.151,100.064l1.429-20.542L342.357,95.056l18.852,10.423a19.843,19.843,0,0,1,9.942-5.415",
    transform: "translate(192.084 44.617)",
    fill: "#ff335f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M336.751,106.713l-8.394-16.327a25.566,25.566,0,0,0-34.415-11.049L186.037,134.8a10.97,10.97,0,0,0-4.743,14.771L267.4,317.106l140.4-72.158Z",
    transform: "translate(101.034 42.929)",
    fill: "#ff335f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M246.022,99.411a1.774,1.774,0,0,1-.145-3.284l20.189-9.263a9.792,9.792,0,0,1,13.182,4.232L289.87,111.76a1.775,1.775,0,0,1-2.174,2.484Z",
    transform: "translate(137.372 48.129)",
    fill: "#aa1a40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M266.263,355.506l110.653-56.873L607.49,180.125l0,0L593.6,187.26l-7.133-13.883L427.292,255.19l3.567,6.942-6.942,3.567-6.942,3.567-3.567-6.939-140.4,72.159L186.9,166.949a10.969,10.969,0,0,1,4.743-14.771L299.552,96.717a25.565,25.565,0,0,1,34.415,11.049l8.394,16.327,6.942-3.567,6.944-3.569,13.4,26.07a35.07,35.07,0,0,0,20.27-3.667l28-14.39,1.6-13.055a5.463,5.463,0,0,1,8.066-4.115l11.433,6.322,30.224-15.534.863-12.4a5.464,5.464,0,0,1,8.175-4.357l11.115,6.4,42.172-21.676-7.134-13.879,6.942-3.569q3.493-1.8,7.039-3.378l-.1-.193L395.582,118.9l-12.8,6.58c-.364.187-.737.34-1.109.5a19.66,19.66,0,0,1-25.423-9.021l-8.394-16.327a41.219,41.219,0,0,0-55.437-17.8L184.51,138.293a26.523,26.523,0,0,0-12.053,34.557c.187.412.353.831.562,1.235l87.288,169.834Z",
    transform: "translate(95.424 25.549)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M465.4,165.045l106.629-54.8a128.145,128.145,0,0,0-161.422-51.8Z",
    transform: "translate(230.377 26.744)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M536.276,104.708h0a6.238,6.238,0,0,1-7.589-1.5A94.744,94.744,0,0,0,433.8,73.185,6.242,6.242,0,0,1,426.7,70l-.287-.557a6.262,6.262,0,0,1,3.493-8.768A94.65,94.65,0,0,1,538.537,95.544a6.263,6.263,0,0,1-2.261,9.163",
    transform: "translate(238.858 31.057)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M397.074,57.089l7.132,13.879,54.9,106.824,7.136,13.881,13.885-7.136,120.725-62.049-3.573-6.942c-.8-1.566-1.643-3.1-2.5-4.624C558.5,46.245,478.48,19.955,411.054,50.143q-3.542,1.585-7.038,3.377ZM579.623,115.85l-106.63,54.8L418.2,64.046a128.143,128.143,0,0,1,161.422,51.8",
    transform: "translate(222.784 21.136)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4",
    "data-name": "Line 4",
    transform: "translate(519.342 291.248)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5",
    "data-name": "Line 5",
    transform: "translate(444.727 146.075)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M307.725,117.359l-13.4-26.07-6.944,3.567-6.942,3.567,71.047,138.234,3.567,6.939L362,240.029l6.943-3.567-3.568-6.941Z",
    transform: "translate(157.345 51.219)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M397.758,100.566a8.943,8.943,0,1,0-3.408-17.209l6.134,3.531a5.464,5.464,0,0,1-5.451,9.471l-6.126-3.526a8.949,8.949,0,0,0,8.852,7.734",
    transform: "translate(218.201 46.388)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M398.311,87.285a8.944,8.944,0,1,1-5.443,9.474l-10.413-5.995a19.893,19.893,0,1,0,5.451-9.469Z",
    transform: "translate(214.241 42.461)",
    fill: "#aa1a40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M366.617,116.471a8.933,8.933,0,0,0,5.942-15.612l-.492,7.048a5.462,5.462,0,0,1-8.093,4.4l-6.184-3.419a8.948,8.948,0,0,0,8.828,7.582",
    transform: "translate(200.743 56.588)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M354.434,98.1l9.21,5.092.732-10.507a19.846,19.846,0,0,0-9.942,5.415",
    transform: "translate(198.86 51.999)",
    fill: "#aa1a40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M376.526,105.168a8.935,8.935,0,1,1-14.769,8.029l-10.52-5.816a19.865,19.865,0,1,0,26.123-14.2Z",
    transform: "translate(196.774 52.28)",
    fill: "#aa1a40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M323.582,124.021a8.943,8.943,0,1,0,15.23-6.354l-.863,7.02a5.465,5.465,0,0,1-5.416,4.8,5.749,5.749,0,0,1-.672-.041,5.464,5.464,0,0,1-4.757-6.09l.861-7.014a8.944,8.944,0,0,0-4.383,7.68",
    transform: "translate(181.55 65.275)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M342.739,121.954a8.947,8.947,0,1,1-10.847-1.327l1.467-11.925a19.824,19.824,0,1,0,10.847,1.31Z",
    transform: "translate(177.623 60.989)",
    fill: "#aa1a40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M326.715,143.285l-.863,7.014a5.461,5.461,0,0,0,4.758,6.088,5.4,5.4,0,0,0,.673.042,5.464,5.464,0,0,0,5.414-4.8l.864-7.019,1.468-11.942L342,108.495l23.211,12.834,10.52,5.817,6.185,3.419a5.462,5.462,0,0,0,8.093-4.4l.492-7.047.835-11.989,1.687-24.248,20.871,12.016,10.413,5.993,6.125,3.526a5.463,5.463,0,1,0,5.452-9.47l-6.133-3.531-10.4-5.99-17.327-9.975L390.9,69.05a5.464,5.464,0,0,0-8.177,4.356l-.864,12.4-1.43,20.542-.73,10.507-9.212-5.092-18.85-10.423-11.435-6.322a5.462,5.462,0,0,0-8.067,4.115l-1.6,13.054L328.18,131.36Z",
    transform: "translate(182.801 38.333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M318.246,190.868,275.521,354.123a14.425,14.425,0,0,1-17.607,10.3l-37.245-9.747c-17.223-4.507-35.4,5.047-40.514,22.1a32.834,32.834,0,0,0,23.127,41.229l37.475,9.807a30.586,30.586,0,0,0,37.334-21.845l5.258-20.094,3.623-13.842,46.376-177.211Z",
    transform: "translate(100.292 107.089)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M115.326,325.6l-37.245-9.747c-17.223-4.507-35.4,5.047-40.514,22.1a32.836,32.836,0,0,0,23.127,41.229l37.475,9.807A30.587,30.587,0,0,0,135.5,367.144l3.152-12.042,5.729-21.9,38.38-146.653-15.1-3.953L132.935,315.3a14.426,14.426,0,0,1-17.609,10.3",
    transform: "translate(20.291 102.451)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M385.924,183.8l-1.793,6.856L184.1,138.307a59.713,59.713,0,0,0-70.011,34.2,44.289,44.289,0,0,1-24.367-51.3,44.132,44.132,0,0,1,53.868-31.521L364.7,147.553A29.733,29.733,0,0,1,385.924,183.8",
    transform: "translate(49.538 49.504)",
    fill: "#68e0da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M406.636,193.363l-3.77,14.407a7.809,7.809,0,0,0-5.576-9.527l-7.551-1.976,1.8-6.856a29.734,29.734,0,0,0-21.222-36.245L149.2,95.3a44.132,44.132,0,0,0-53.866,31.521,44.288,44.288,0,0,0,24.365,51.3,58.961,58.961,0,0,0-2.794,8.032l-.116.437a57.539,57.539,0,0,0-1.33,6.687A59.726,59.726,0,0,1,153.155,80.2l221.109,57.865a45.359,45.359,0,0,1,32.372,55.3",
    transform: "translate(43.928 43.891)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M367.033,182.855l-10.774,41.168L195.09,181.845A59.834,59.834,0,0,0,129.075,208.3a44.421,44.421,0,0,1-15.935-46.27l.1-.376a44.1,44.1,0,0,1,53.767-31.143Z",
    transform: "translate(62.683 72.404)",
    fill: "#a7eae8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M389.715,184.869l-14.7,56.18a5.378,5.378,0,0,0,.136-.707,8.686,8.686,0,0,0,.092-1.459,6.6,6.6,0,0,0-.086-.846,2.5,2.5,0,0,0-.107-.512,7.662,7.662,0,0,0-2.487-4.249,7.291,7.291,0,0,0-.983-.742,8.176,8.176,0,0,0-2.163-.921l-7.551-1.976,10.775-41.168L172.61,136.12a44.107,44.107,0,0,0-53.768,31.143l-.1.378a44.419,44.419,0,0,0,15.935,46.27,60.293,60.293,0,0,0-4.148,8.08,58.65,58.65,0,0,0-2.282,6.5,60.229,60.229,0,0,1-25.939-58.117,57.85,57.85,0,0,1,1.332-6.687l.114-.439a58.723,58.723,0,0,1,2.8-8.03,59.713,59.713,0,0,1,70.011-34.2l207.578,54.323a7.808,7.808,0,0,1,5.575,9.527",
    transform: "translate(57.079 66.792)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M366.473,216.464a8.762,8.762,0,0,0,.092-1.461,6.873,6.873,0,0,0-.085-.844,2.639,2.639,0,0,0-.109-.514,7.68,7.68,0,0,0-2.485-4.249,7.463,7.463,0,0,0-.985-.742,8.169,8.169,0,0,0-2.162-.921L192.018,163.578A59.831,59.831,0,0,0,126,190.032a60.023,60.023,0,0,0-4.146,8.08,58.887,58.887,0,0,0-2.284,6.5c-.1.329-.215.638-.3.971A58.784,58.784,0,0,0,125.3,250.8a61.526,61.526,0,0,0,37.417,28.623L230,297.026A111.8,111.8,0,0,0,366.313,217.26l.024-.091a5.433,5.433,0,0,0,.136-.706m-132.522,65.46-67.281-17.608a45.828,45.828,0,0,1-27.852-21.327A43.308,43.308,0,0,1,134.33,209.7a41.989,41.989,0,0,1,1.908-5.5,44.139,44.139,0,0,1,51.829-25.517l160.866,42.1a96.2,96.2,0,0,1-114.982,61.144",
    transform: "translate(65.755 90.671)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M343.319,215.168a96.2,96.2,0,0,1-114.982,61.144L161.057,258.7A45.825,45.825,0,0,1,133.2,237.377a43.309,43.309,0,0,1-4.488-33.287,41.442,41.442,0,0,1,1.907-5.5,44.134,44.134,0,0,1,51.828-25.519Z",
    transform: "translate(71.368 96.284)",
    fill: "#c0f9f9"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRunnaMini);
export default __webpack_public_path__ + "static/media/RunnaMini.8b97e533834fb19dc817667b4a71e074.svg";
export { ForwardRef as ReactComponent };